import { useCallback, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

export const useCopilotMessageClipboard = (setError: Dispatch<SetStateAction<string | null>>) => {
    const { t } = useTranslation();

    return useCallback(
        async (content: string, renderedContent?: HTMLElement | null) => {
            try {
                const plainText = renderedContent?.innerText ?? content;
                if (renderedContent && navigator.clipboard.write && typeof ClipboardItem !== 'undefined') {
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            'text/html': new Blob([renderedContent.innerHTML], { type: 'text/html' }),
                            'text/plain': new Blob([plainText], { type: 'text/plain' })
                        })
                    ]);
                } else {
                    await navigator.clipboard.writeText(plainText);
                }
                setError(null);
            } catch {
                setError(t('copilotCopyError'));
            }
        },
        [setError, t]
    );
};
